
/* This work is licensed under a Creative Commons Attribution 4.0 International License - http://creativecommons.org/licenses/by/4.0
 * Created for clairebyrne.ie and all thanks to data.localgov.ie
 */

//some control variables
var speed = 1;
var leftPadding = 10;
var nameSpace = 200;
var startLeft = leftPadding+nameSpace;
var voteWidth = $(".animation_container").width()-startLeft-50;
var w=constituency_slug+"_";
var con=w+"countGroup";
var running = true;
var earlyStage = true;

if(ward){
    //set the top right bit
    var quota = parseInt(ward[w+"constituencycountGroup"][0]["Quota"]);
    var seats = parseInt(ward[w+"constituencycountGroup"][0]["Number_Of_Seats"]);
    $("#quota-span").text(quota);
    $("#seats-span").text(seats);
    $("#theline").css({top:3+(seats+1)*45});
    var qFactor = voteWidth/quota; //all actual vote counts are multiplied by this to get a div width in proportion

    //This data is pulled from data.localgov.ie all thanks goes to them for making it available in an open format.
    //Minor issue is that only the bigish parties are marked so can't add PPP, S, IND etc before appropriate candidates.
    //Seems to be slight issue with unicode too, javascript should handle unicode but there is some format difference betweeen what's in the json
    //http://data.localgov.ie/virtual/Elections/toJson.php?url=http://data.localgov.ie/fingal_castleknock_count?LIST%26ID=*
    //http://data.localgov.ie/virtual/Elections/toCsv.php?url=fingal/292/Count.csv"


    /**
     * The data gets parsed into two dictionaries containing snippets of the following form
     * candidate data object of the form {
     *  id:String,     candidate's id in data
     *  name:String,   candidate's name
     *  status:String, is the candidate elected or excluded
     *  party:String   party string suitable to use as html/css class
     * }
     *
     * countData of the form {
     *  total:Number,      the total for a candidate at specfic round of the count
     *  status:String,     the status of the candidate at specfic round
     *  order:Number       a candidates order at a specfic round
     *  transfers:Boolean  does this candidate transfer in this round
     * }
     **/

    var candidatesDict = {}; //Dictionary of candidates {} id as key
    var candidates = [];     //Array of candidates in order first seen in data
    var countDict = {};      //Dictionary of counts, first level key is count number, which points to a dict of countData with key candidate id
    var transferDict={};     //Corresponding dictionary of transfers indexed by [count number][candidate id]
    var counts = 1;

    //loop through all the data and populate the various dictionaries
    for (var i=0; i<data[con].length; i++) {
        if (!(data[con][i]["Count_Number"] in countDict)) {
            countDict[data[con][i]["Count_Number"]] = {};
        }
        if (!(data[con][i]["Count_Number"] in transferDict)) {
            transferDict[data[con][i]["Count_Number"]] = {};
        }
        countDict[data[con][i]["Count_Number"]][data[con][i]["Candidate_Id"]] = {
            total:(domain_prefix == "in") ? parseInt(data[con][i]["Total_Votes"]) : parseFloat(data[con][i]["Total_Votes"]).toFixed(2),
            status:(typeof(data[con][i]["Status"])=="string")?data[con][i]["Status"]:"",
            order:0,
            transfers:((data[con][i]["Status"] == "Excluded" && parseInt(data[con][i]["Transfers"]) < 0) ||
                       (data[con][i]["Status"] == "Elected" && parseInt(data[con][i]["Transfers"]) < 0))
        }

        transferDict[data[con][i]["Count_Number"]][data[con][i]["Candidate_Id"]] = (domain_prefix == "in") ? Math.max(0, parseInt(data[con][i]["Transfers"], 10)) : parseFloat(data[con][i]["Transfers"]).toFixed(2);

        if (!(data[con][i]["Candidate_Id"] in candidatesDict)) {
            var party = data[con][i]["Party_Name"];
            if (typeof(party)!="string"){ party = "Non-Party";}
            party=party.replace(/\s+/g,"-");
            if (party_details[party]){ var short_party = party_details[party]['text']; var color = party_details[party]['color'];} else { var short_party = ""; var color = '#333';}
            candidates.push({
                name:'<img src="'+data[con][i]["image"]+'" width="40" height="40" alt="'+data[con][i]["Firstname"]+" "+((typeof(data[con][i]["Surname"])=="string")?data[con][i]["Surname"]:"")+'" /> <strong>'+data[con][i]["Firstname"]+" "+((typeof(data[con][i]["Surname"])=="string")?data[con][i]["Surname"]:"")+'</strong> <small alt="'+data[con][i]["Party_Name"]+'" title="'+data[con][i]["Party_Name"]+'"><i style="background: '+color+'"></i>'+short_party+'</small>',
                id:data[con][i]["Candidate_Id"],
                status:"",
                party:party
            });
            candidatesDict[data[con][i]["Candidate_Id"]] = {
                name:'<img src="'+data[con][i]["image"]+'" width="40" height="40" alt="'+data[con][i]["Firstname"]+" "+((typeof(data[con][i]["Surname"])=="string")?data[con][i]["Surname"]:"")+'" /> <strong>'+data[con][i]["Firstname"]+" "+((typeof(data[con][i]["Surname"])=="string")?data[con][i]["Surname"]:"")+'</strong> <small alt="'+data[con][i]["Party_Name"]+'" title="'+data[con][i]["Party_Name"]+'"><i style="background: '+color+'"></i>'+short_party+'</small>',
                id:data[con][i]["Candidate_Id"],
                status:"",
                party:party
            };
        }
        counts = Math.max(counts, parseInt(data[con][i]["Count_Number"], 10));
    }

    var qFactor = voteWidth/biggest_total; //all actual vote counts are multiplied by this to get a div width in proportion
    $("#theline").css({width:startLeft+(quota*qFactor)-6});
    $("#thepost").css({left:startLeft+(quota*qFactor)});

    //once we have all the data in the countDict we can now go through each count and order it
    //we do this in order as once a candidate is elected we store their final order in the candidatesDict and reuse it subsquent counts
    //only sorting candidates that are not eliminated or elected

    for (var k=1; k<=counts;k++){
        if (countDict.hasOwnProperty(k)) {
            adjustOrder(countDict[k]);
        }
    }

    //now we have the data set up we just hook up our links to functions

    $("#pause-replay").click(function(event) {
        event.preventDefault();
        if ($(this).text() == "Pause") {
            $(this).text("Resume");
            pause();
        } else if ($(this).text() == "Resume") {
            $(this).text("Pause");
            resume();
        } else {
            $(this).text("Pause");
            replay(1);
        }
    });

    $("#step").click(function(event) {
        event.preventDefault();
        step();
    });

    $("#again").click(function(event) {
        event.preventDefault();
        again();
    });

    firstCount();  //run the first count
    var countNumber = 2;  //global loop variable
    //set the advance count function to run in a loop
    pause();
}else{
    //if we didn't load a ward var then we have no data yet
    $("#animated_results").text("There is no data up for this ward at present");
}

//the magic, simple enough, append some divs and animate their width's to final position
//then animate their top to final position and move the name div at the same time
function firstCount(){
    $("#count-span").text("1 / "+counts);
    $("#thepost").height(candidates.length*45);
    $("#animated_results").height((candidates.length*45)+20);
    for(var j=0;j<candidates.length;j++){
        $('<div id="cname'+candidates[j].id+'" class="candidateLabel person" style="top:'+((j*45)) +'px;left:0px;">'+candidates[j]["name"]+'</div>')
        .appendTo("#animated_results");

        var vote_total = countDict[1][candidates[j].id]["total"] ? countDict[1][candidates[j].id]["total"] : '';
        //if modulus equals with 0, we have a whole number
        if (vote_total % 1 === 0) {
            //The Math method below will return a whole number
            vote_total = Math.round(vote_total);
        }

        $('<div data-candidate="'+candidates[j].id+'" id="candidate'+candidates[j].id+'" class="votes '+candidates[j]["party"]+'" style="top:'+((j*45)) +'px;left:'+startLeft+'px;"></div>')
        .appendTo("#animated_results")
        .animate({width:countDict[1][candidates[j].id]["total"] * qFactor},1500*speed).text(vote_total)
        .animate({top:(countDict[1][candidates[j].id]["order"]*45)});
        if ((vote_total*qFactor)<40) {
            $('#candidate'+candidates[j].id).text('');
        }
            //Original code that requires newer jQuery version
            /*.animate({top:(countDict[1][candidates[j].id]["order"]*45)},{
                duration:500*speed,
                start:function(){
                    $("#cname"+$(this).data('candidate'))
                    .animate({top:(countDict[1][$(this).data('candidate')]["order"]*45)},500*speed)
                }
            });*/

        //Had to add this bit of code as we are using older jQuery version
        $("#cname"+candidates[j].id).delay(1500).animate({top:(countDict[1][candidates[j].id]["order"]*45)},500*speed);
        //check status of the candidate as on the last round it might be elected even though had not reached the quota
        if (countDict[1][candidates[j].id]["status"] == 'Elected') {
            $("#cname"+candidates[j].id).attr("data-badge", "✓");
        }
    }

    for (var key in party_details) {
        if (party_details.hasOwnProperty(key)) {
            $("." + key + "" ).css({"background-color": party_details[key]['color']});
         }
     }
}

//find the first candidate who is transferring, all transfers from the round start from here
//append some divs with width relative to transfer number, animate them to their candidates current order
//then animate them accross to end of candidates vote pile, when complete remove the new div and update the candidates div width
//finally run the reorder animation
function advanceCount(){
    var transfered=false;
    if(countNumber in countDict){
        earlyStage = true;
        var i = countNumber;
        $("#count-span").text(countNumber + ' / ' +counts);
        for (var j=0;j<candidates.length;j++) {
            if (countDict[i][candidates[j].id]["transfers"]) {
                //we have to break it down now instead
                $("#candidate"+candidates[j].id).width(countDict[i][candidates[j].id]["total"] * qFactor);
                var transfers = transferDict[i];
                var left = startLeft + countDict[i][candidates[j].id]["total"] * qFactor;
                var top = (countDict[i-1][candidates[j].id]["order"]*45);
                if (!transfered){
                    for (var t=0;t<candidates.length;t++) {
                        if (countDict[i][candidates[t].id]["transfers"] == false) {
                            var localLeft = startLeft+countDict[i-1][candidates[t].id]["total"] * qFactor;
                            $('<div data-candidate="'+candidates[t].id+'" style="width:'+transfers[candidates[t].id] * qFactor+'px;left:'+left+'px; top:'+top+'px;" class="votes '+candidates[t]["party"]+'"></div>')
                                .appendTo("#animated_results").delay(300*speed)
                                .animate({top:(countDict[i-1][candidates[t].id]["order"]*45), left:startLeft+voteWidth+20},900*speed, function(){
                                    earlyStage = false;
                                    if (transfers[$(this).data('candidate')] >0 ){
                                        if (((Math.max(0, countDict[i-1][$(this).data('candidate')]["total"])+Math.max(0, transfers[$(this).data('candidate')]))*qFactor) > 40) {
                                            $("#candidate"+$(this).data('candidate'))
                                            .text(countDict[i-1][$(this).data('candidate')]["total"]+" + "+transfers[$(this).data('candidate')]);
                                        }
                                    }
                                }).delay(100*speed)
                                .animate({left:localLeft},900*speed, function(){
                                    var vote_total = countDict[i][$(this).data('candidate')]["total"] ? countDict[i][$(this).data('candidate')]["total"] : '';
                                    //if modulus equals with 0, we have a whole number
                                    if (vote_total % 1 === 0) {
                                        //The Math method below will return a whole number
                                        vote_total = Math.round(vote_total);
                                    }

                                    $("#candidate"+$(this).data('candidate')).width(countDict[i][$(this).data('candidate')]["total"] * qFactor)
                                    .text(vote_total)
                                    .animate({top:(countDict[i][$(this).data('candidate')]["order"]*45)});
                                            //Original code that requires newer jQuery version
                                            /*.animate({top:(countDict[i][$(this).data('candidate')]["order"]*45)},{
                                                 duration:500*speed,
                                                 start:function(){
                                                     $("#cname"+$(this).data('candidate'))
                                                     .animate({top:(countDict[i][$(this).data('candidate')]["order"]*45)},500*speed)
                                                 }
                                             });                                    */

                                    //TODO:at this point we'd like to animate to new order
                                    if (vote_total*qFactor<40) {$("#candidate"+$(this).data('candidate')).text('');}
                                    $(this).remove();
                                });
                                //Had to add this bit of code as we are using older jQuery version
                                $("#cname"+candidates[t].id).delay(2100).animate({top:(countDict[i][candidates[t].id]["order"]*45)},500*speed);
                                //check status of the candidate as on the last round it might be elected even though had not reached the quota
                                if (countDict[i][candidates[t].id]["status"] == "Elected") {
                                    $("#cname"+candidates[t].id).attr("data-badge", "✓");
                                } else {
                                    $("#cname"+candidates[t].id).removeAttr("data-badge");
                                }

                            left = left + transfers[candidates[t].id] * qFactor;
                        }
                    }
                    //could put dead votes in here
                    transfered = true;
                }

                var vote_total = countDict[i][candidates[j].id]["total"] ? countDict[i][candidates[j].id]["total"] : '';
                $("#candidate"+candidates[j].id).width(countDict[i][candidates[j].id]["total"] * qFactor).text(vote_total);
                if (countDict[i][candidates[j].id]["status"] == "Elected") {
                    $("#cname"+candidates[j].id).attr("data-badge", "✓");
                }
            }
        }

        for (var key in party_details) {
            if (party_details.hasOwnProperty(key)) {
                $("." + key + "" ).css({"background-color": party_details[key]['color']});
            }
        }
    }else{
        clearInterval(loop);
        $("#pause-replay").text("Replay");
    }
    countNumber += 1;

}

function pause(){
    if (typeof loop != 'undefined') {
        clearInterval(loop);
    }

    running = false;
}

function resume(){
    advanceCount();
    loop = window.setInterval(advanceCount,4000*speed);
    running = true;
}

function replay(s){
    if (running) {
        clearInterval(loop);
    }
    $("#count-span").text("1 \ " + counts);
    $(".candidateLabel").remove();
    $(".votes").remove();
    speed = s;
    firstCount();
    countNumber = 2;
    loop = window.setInterval(advanceCount,4000*speed);
    running = true;
}

function step(){
    if (running) {
        clearInterval(loop);
    }
    playStep(countNumber);
    if (running) {
        loop = window.setInterval(advanceCount,4000*speed);
    }
}

function again() {
    if (running) {
        clearInterval(loop);
    }

    if (earlyStage && countNumber>2) {
        countNumber-=2;
    }else if (countNumber>1) {
        countNumber--;
    }
    playStep(countNumber);
    if (running) {
        loop = window.setInterval(advanceCount,4000*speed);
    }
}

function advanceStep(){
    advanceCount();
}

function playStep(i){
    countNumber = i;
    if (countNumber in countDict) {
        $('div').stop(true, true);
        $(".candidateLabel").remove();
        $(".votes").remove();
        if (i>1){
            for(var j=0;j<candidates.length;j++){
                $('<div style="top:'+((countDict[i-1][candidates[j].id]["order"]*45)) +'px;left:0px;" id="cname'+candidates[j].id+'" class="candidateLabel person '+candidates[j]["party"]+'_label">'+candidates[j]["name"]+'</div>')
                .appendTo("#animated_results");
                $('<div data-candidate="'+candidates[j].id+'" id="candidate'+candidates[j].id+'" class="votes '+candidates[j]["party"]+'" style="top:'+((countDict[i-1][candidates[j].id]["order"]*45)) +'px;left:'+startLeft+'px;"></div>')
                .appendTo("#animated_results");
                var vote_total = countDict[i-1][candidates[j].id]["total"] ? countDict[i-1][candidates[j].id]["total"] : '';

                $("#candidate"+candidates[j].id).width(countDict[i-1][candidates[j].id]["total"] * qFactor).text(vote_total);
            }
            advanceCount();
        } else {
            firstCount();
            countNumber = 2;
        }
    }

    for (var key in party_details) {
        if (party_details.hasOwnProperty(key)) {
            $("." + key + "" ).css({"background-color": party_details[key]['color']});
         }
     }
}

function adjustOrder(singleCountDict){
    var copy=[];
    var start=0;
    var end=0;

    for (var k in singleCountDict){
        if (singleCountDict.hasOwnProperty(k)) {
            var data = singleCountDict[k];
            if (data["status"] == "Elected" && candidatesDict[k]["status"]) {
                start++;
                data["order"] = candidatesDict[k]["order"];
            }else if (singleCountDict[k]["status"] == "Excluded" && candidatesDict[k]["status"]) {
                end++;
                data["order"] = candidatesDict[k]["order"];
            }else{
                copy.push({
                    key: k,
                    count: (domain_prefix == "in") ? data["total"] : parseInt(data["total"])
                });
            }
        }
    }

    copy.sort(function (a, b) {
        if (a.count > b.count)
          return -1;
        if (a.count < b.count)
          return 1;
        // a must be equal to b
        return 0;
    });

    //candidatesDict is global and we use it here to store state of where those people we're not ordering are elected
    for(var i=0;i<copy.length;i++){
        singleCountDict[copy[i]["key"]].order = i+start;
        candidatesDict[copy[i]["key"]].order = i+start;
        if (singleCountDict[copy[i]["key"]]["status"] != "" ) {
            candidatesDict[copy[i]["key"]].status = singleCountDict[copy[i]["key"]]["status"];
        }
    }
}
